'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _footer = require('./footer.styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SelectInput = function SelectInput(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value;
  return _react2.default.createElement(_footer.ResulstSelect, {
    onChange: onChange,
    value: value
  }, _react2.default.createElement('option', null, '10'), _react2.default.createElement('option', null, '15'), _react2.default.createElement('option', null, '20'), _react2.default.createElement('option', null, '25'));
};
SelectInput.defaultProps = {
  isRequired: false,
  placeholder: ''
};
exports.default = SelectInput;